import $ from 'jquery';

export default (container = document) => {
  $('[data-rte-hero-blog-carousel]', container).each((i, carousel_container) => {
    const $carousel_container = $(carousel_container);
    $carousel_container.addClass('HeroBlogCarousel__container').addClass('Animate');

    // weird things happen when you use the same format as shopify...
    const possibly_json = $carousel_container.find('[data-settings]').html();
    const json = possibly_json.replace('// <![CDATA[', '').replace('// ]]>', '');
    const data = JSON.parse(json); 
    // blocks also exist but we dont need them in the js for now
    const {settings} = data;  
    let settings_logo = settings.logo;
    let settings_logo_alt = settings.logo_alt;

    if (settings.logo.url) {
      settings_logo = settings.logo.url;
    }

    if (settings.logo.alt) {
      settings_logo_alt = settings.logo.alt;
    }

    const caption_html = `
      <div class="HeroBlogCarousel__content-wrapper">
        ${settings.text_background ? `<div class="HeroBlogCarousel__text-background" style="background-image: url('${settings.text_background}');"></div>` : ''}
        <div class="HeroBlogCarousel__content">
          <div class="HeroBlogCarousel__content-alignment">
            <div class="HeroBlogCarousel__content-inner">
              ${settings_logo ? `<img src="${settings_logo}" ${settings_logo_alt ? `alt="${settings_logo_alt}"` : ''} />` : ''}
              ${settings.wysiwyg || ''}
            </div>
          </div>
        </div>
      </div>
    `;

    const $carousel = $carousel_container.find('[data-carousel]').clone();
    let num_slides = $carousel.find('[data-slide]').length;
    const carousel_id = `HeroBlogCarousel--${i + 1}`;

    if (!$carousel.attr('id')) {
      $carousel.attr('id', carousel_id);
    }

    if (num_slides < 10) {
      num_slides = `0${num_slides}`;
    }

    $carousel.addClass('HeroBlogCarousel').addClass('Gallery').addClass('Gallery--bottom-arrows').addClass('AnimateOnLoad').addClass('Animate--slide-up');
    $carousel.append(`<div class="Gallery__position Gallery__position--bottom Gallery__position--dark"><span data-current-position>01</span> / ${num_slides}</div>`);
    const carousel_html = $carousel.wrap('<div></div>').parent().html();

    const carousel_wrapper = `
      <div class="HeroBlogCarousel__wrapper">
        ${settings.carousel_background ? `<div class="HeroBlogCarousel__carousel-background" style="background-image: url('${settings.carousel_background}');"></div>` : ''}
        ${carousel_html}
      </div>
    `;

    $carousel_container.html(`${caption_html}${carousel_wrapper}`);
    $carousel_container.addClass('Animate--slide-up').addClass('Animate--slide-up');
  });
};